import React, { useLayoutEffect, useEffect, useRef, useState } from "react"
import Layout from "../components/layout"
import TransitionLink from 'gatsby-plugin-transition-link'
import { gsap } from "gsap";
import VisibilitySensor from 'react-visibility-sensor'
import ReactPlayer from 'react-player'
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { StaticImage } from "gatsby-plugin-image"
import Footer from "../components/footer"
import PjmGlance from "../components/pjm-glance"
import useWindowSize from "../hooks/useWindowDimensions"
import VideoSrc from "../videos/Sprint1_Welcome_3Pillars_DESKTOP.mp4"
import arrowLeft from "../images/yellow-arrow.svg"
import VideoSrcMobile from "../videos/Sprint1_Welcome_3Pillars_MOBILE.mp4"
import chevronDown from "../images/angle-down.svg"
import nextImage from "../images/double-profile-rev.jpg"
import prevImage from "../images/BoardWeb_2022_Takahashi_Mark.jpg"
import nextRings from "../images/RINGS_MAGENTA_YELLOW.svg"
import { Link } from "gatsby"
import ringsgy from "../images/RINGS_GREEEN_YELLOW.svg"
import ringsmy from "../images/RINGS_MAGENTA_YELLOW.svg"
import ringscy from "../images/RINGS_CYAN_YELLOW.svg"
import ringsbm from "../images/RINGS_BLUE_MAGENTA.svg"
import ringsby from "../images/RINGS_BLUE_YELLOW.svg"

import "../components/pages.scss"

gsap.registerPlugin(ScrollTrigger);

const WelcomePage = (props) => {
    const size = useWindowSize();
    const firstRow = useRef();
    const circles = useRef([]);
    const navList = useRef();
    const [desktopViewState, setDesktopViewState] = useState(null);

    useLayoutEffect(() => {
        // console.log(circles);
        for(let x = 0; x < circles.current.length; x++) {
            gsap.to(circles.current[x], {
                x: (i, target) => -1000 * target.dataset.speed,
                ease: "none",
                scrollTrigger: {
                    trigger: circles.current[x],
                    scrub: true,
                }
            });
        }

        gsap.from(firstRow.current, { y: 200, ease: "power2"});
        gsap.from(navList.current, {
            y: "-100%",
            duration: .35,
            ease: "power2"
        });
    }, []);

    function exitAnimation(exit, node, int) {
        gsap.to(navList.current, {
            y: "-100%",
            duration: .35,
            ease: "power2"
        });
    }

    const [playVideo, setPlayVideo] = useState(false);
	function onChangeVideo(isVisible) {
		if(isVisible) {
			setPlayVideo(true);
		}
	}

	const [videoUrl, setVideoUrl] = useState(VideoSrc);
	useEffect(() => {
		const mql = window.matchMedia('(min-width: 64rem)');
		setDesktopViewState(mql.matches);

		if(desktopViewState) {
			setVideoUrl(VideoSrc);
		} else {
			setVideoUrl(VideoSrcMobile);
		}
	}, [size, desktopViewState]);

    return (
        <Layout>
            <main className="page welcome">
                <title>Welcome Page</title>
                <div className="row nav">
                    <div className="col-xs-12">
                        <nav>
                            <ul ref={navList}>
                                <li>
                                    <Link
                                        className="back-button"
                                        activeClassName="active"
                                        to="/"
                                        state={{ pageId: 0 }}
                                    >
                                        <img src={arrowLeft} alt=""/>
                                    </Link>
                                </li>
                                <li className="blue-bar">|</li>
                                <li data-url="welcome" className="text--yellow">Welcome</li>
                            </ul>
                        </nav>
                    </div>
                </div>
                <div className="page-set">
                    <div className="wrapper">
                        <div className="container">
                            <section className="panel">
                                <div className="wrap">
                                    <div className="profile">
                                        <StaticImage loading="eager" objectFit="contain" placeholder="blurred" quality="50" className="avatar" src="../images/Hero_01_Welcome.jpg" alt="" />
                                        <img className="rings" src={ringsgy} alt="" /> 
                                    </div>
                                    <div className="info">
                                        <div className="title--super text--outline">ON COMMON</div>
                                        <h1>GROUND</h1>
                                        <div className="button-wrap">
                                            <TransitionLink
                                                className="button"
                                                to="/"
                                                exit={{
                                                    trigger: ({ exit, node }) => exitAnimation(exit, node, 0),
                                                    length: .5,
                                                    // state: { matrix1: circle1Matrix, matrix2: circle2Matrix }
                                                }}
                                                entry={{
                                                    delay: 0.5,
                                                }}
                                            >
                                                Read Welcome
                                            </TransitionLink>
                                        </div>
                                    </div>
                                    <img className="chevron-down" src={chevronDown} alt="" /> 
                                </div>
                                <div 
                                    // style={{transform: circle1Matrix}}
                                    className="circle--pink top"
                                    ref={(element) => circles.current[0] = element}
                                    data-speed=".4"
                                ></div>
                                <div
                                    // style={{transform: circle2Matrix}}
                                    className="circle--blue top" 
                                    ref={(element) => circles.current[1] = element}
                                    data-speed="-.2"
                                ></div>
                            </section>
                        </div>
                    </div>
                </div>
                <div className="row row-wrapper first-row content" ref={firstRow}>
                    <div className="col-xs-12">
                        <h2>Powered By Purpose</h2>
                        <p className="text text--large">PJM found a renewed sense of purpose at the dawn of 2021. After nearly a year of responding to and transitioning through the global pandemic, PJM emerged with a focused plan to confront the historic energy transition ahead. PJM was committed and collaborative in our efforts to keep the electric grid operating reliably, advance competitive markets and build momentum toward the goals we set forth. From our team to our broad stakeholder community, our common purpose has been a uniting force as we work together to realize the grid of the future.</p>
                        <h5>STRATEGIC MOMENTUM</h5>
                        <p className="text">In early 2021, PJM, as the neutral, independent operator of the nation’s largest grid, developed a five-year strategic plan guided by our core purpose to preserve reliability in ways that are efficient and cost-effective, harnessing the power of competitive markets to achieve these objectives while planning for and facilitating a cleaner and more sustainable future. </p>
                        <h5>Three Pillars</h5>
                        <p className="text">The three pillars of the strategic plan served as a guide in 2021 throughout transparent, committed collaboration between PJM, the PJM Board of Managers, members and other stakeholders.</p>
                        <div className="left-indent">
                            <h6>1. Facilitating Decarbonization</h6>
                                <ul>
                                    <li>PJM helps to facilitate a reliable and cost-effective energy transition.</li>
                                    <li>PJM serves as a trusted, unbiased analytics provider to inform policy decisions.</li>
                                    <li>PJM works to drive consensus for market-based, regional solutions.</li>
                                </ul>
                            <h6>2. Planning the Grid of the Future</h6>
                                <ul>
                                    <li>PJM holds a unique role as the operator and administrator of the largest grid in the U.S.</li>
                                    <li>PJM is facilitating an efficient transition to the grid of the future.</li>
                                </ul>
                            <h6>3. Fostering Innovation</h6>
                                <ul>
                                    <li>PJM creates an environment to foster grid innovation.</li>
                                </ul>
                        
                        </div>
                        
                        <div className="m-t-40 m-b-40">
                            <VisibilitySensor partialVisibility={true} offset={{top: 100}} onChange={onChangeVideo}>
                                <div style={{position: 'relative'}}>
                                    <ReactPlayer 
                                        playing={playVideo}
                                        url={videoUrl} 
                                        width='100%'
                                        height='100%'
                                        className='react-player'
                                        muted
                                        playsinline
                                    />
                                </div>
    	    			    </VisibilitySensor>                       
                        </div>
                        <h5>A Firm Foundation</h5>
                        <p className="text">The strategic initiatives required to enable the energy transition in a reliable and efficient manner rest on a firm foundation that includes dedicated employees, stakeholder governance and risk management.</p>
                         <div
                            className="circle--green page-1" 
                            ref={(element) => circles.current[2] = element}
                            data-speed="-.2"
                        ></div>
                    </div>
                </div>
                <PjmGlance />
            </main>
            <Footer 
                nextLink="/board-ceo-letters" 
                nextImage={nextImage}
                nextText="Next &gt;"
                nextTitle="Board & CEO Letters"
                nextButton="Read More" 
                nextRings="" 
                prevLink="" 
                prevImage=""
                prevText=""
                prevButton=""
                prevTitle=""  
                prevRings="" 
            />
        </Layout>
    )
}

export default WelcomePage
